import React from 'react';

import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

interface CellLinkWithIconProps<TData, TValue> extends CellContext<TData, TValue> {
    to: string | ((row: TData, value: TValue) => string);
    render?: (value: TValue, row: TData) => React.ReactNode;
    emptyFallback?: React.ReactNode;
    hasPermissions?: boolean;
}

export function CellLinkWithIcon<TData, TValue>({
    getValue,
    row,
    to,
    render,
    emptyFallback = '-',
    hasPermissions = true,
}: CellLinkWithIconProps<TData, TValue>) {
    const navigate = useNavigate();
    const value = getValue();

    if (value == null) return <>{emptyFallback}</>;

    const path = typeof to === 'function' ? to(row.original, value) : to;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(path);
    };

    return hasPermissions ? (
        <div
            onClick={handleClick}
            className="text-primary-700 hover:text-primary-600 flex cursor-pointer items-center gap-1 whitespace-nowrap font-medium"
        >
            {render ? render(value, row.original) : String(value)}
            <FontAwesomeIcon icon={faArrowUpRight} />
        </div>
    ) : (
        <div className="whitespace-nowrap">{String(value)}</div>
    );
}
